import React from 'react';
import styled from 'styled-components';

import { motion } from 'framer-motion';

const Container = styled.div`
    width: 50%;
    max-width: 5rem;
    background-color: ${props => props.styles.backgroundColor};
`

const defaultStyle = {
    size: '5rem',
    color: '#000',
    backgroundColor: 'transparent'
}

const CheckGraphic = props => {
    const {
        onSelect,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    const strokeStyle = {
        fill: 'none',
        stroke: updatedStyle['color'],
        strokeWidth: 3,
        strokeLineJoin: 'round',
        strokeMiterLimit: 10
    }
    return (
        <Container styles={updatedStyle}>
            <svg viewBox={`0 0 ${updatedStyle['size']} ${updatedStyle['size']}`}>
                <motion.path
                    d='M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z'
                    fill="transparent"
                    strokeWidth="3"
                    stroke="var(--focus-color)"
                    strokeLinecap="round"
                    initial={{ pathLength: 0, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    />
                
                <motion.path
                    d='M11.6,20 15.9,24.2 26.4,13.8'
                    fill="transparent"
                    strokeWidth="3"
                    stroke="var(--focus-color)"
                    strokeLinecap="round"
                    initial={{ pathLength: 0, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    />
            </svg>

        </Container>
    )
}

export default CheckGraphic